import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const THEMES = {
  default:    { primary: '#1A4D2E', accent: '#D4A373', bg: '#F5F5F0' },
  ocean:      { primary: '#1B3A5C', accent: '#F0A500', bg: '#F0F4F8' },
  slate:      { primary: '#334155', accent: '#6366F1', bg: '#F8FAFC' },
  burgundy:   { primary: '#6B1D2A', accent: '#D4A373', bg: '#FDF8F6' },
  charcoal:   { primary: '#1C1C1C', accent: '#E2B659', bg: '#F5F5F5' },
  teal:       { primary: '#0F766E', accent: '#FB923C', bg: '#F0FDFA' },
  midnight:   { primary: '#0F172A', accent: '#38BDF8', bg: '#F1F5F9' },
  plum:       { primary: '#581C87', accent: '#F59E0B', bg: '#FAF5FF' },
  espresso:   { primary: '#3E2723', accent: '#FFB74D', bg: '#FBF8F5' },
  emerald:    { primary: '#065F46', accent: '#F472B6', bg: '#ECFDF5' },
  steel:      { primary: '#1E293B', accent: '#22D3EE', bg: '#F8FAFC' },
  terracotta: { primary: '#9A3412', accent: '#84CC16', bg: '#FFFBEB' },
};

const ThemeContext = createContext({ themeId: 'default', colors: THEMES.default });

export const ThemeProvider = ({ children }) => {
  const [themeId, setThemeId] = useState('default');

  useEffect(() => {
    axios.get(`${API}/site-settings`)
      .then(res => {
        const id = res.data.theme || 'default';
        setThemeId(id);
        applyTheme(id);
      })
      .catch(() => applyTheme('default'));
  }, []);

  const applyTheme = (id) => {
    const colors = THEMES[id] || THEMES.default;
    const root = document.documentElement;
    root.style.setProperty('--color-primary', colors.primary);
    root.style.setProperty('--color-accent', colors.accent);
    root.style.setProperty('--color-bg', colors.bg);
    setThemeId(id);
  };

  const updateTheme = (id) => {
    applyTheme(id);
  };

  const colors = THEMES[themeId] || THEMES.default;

  return (
    <ThemeContext.Provider value={{ themeId, colors, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
